/**
 * Per-language display overlay for return-flow elements: stable element id
 * (a multiple choice step or option uuid) -> field -> translated text.
 *
 * The overlay only ever affects rendering. The canonical English text stays
 * on the flow itself: condition predicates (isDamaged/isWrongProduct) and
 * stored answers keep reading the untranslated values.
 */
export type FlowElementTextOverlay = Record<string, Record<string, string>>;

/**
 * Translatable fields across flow elements: message/description on multiple
 * choice steps, name on options.
 */
export const FLOW_ELEMENT_TRANSLATABLE_FIELDS = [
  "message",
  "description",
  "name",
] as const;

export type FlowElementTranslatableField =
  (typeof FLOW_ELEMENT_TRANSLATABLE_FIELDS)[number];
